const alphabet =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

export const generateRecoveryPassphrase = (): string => {
  const bytes = new Uint8Array(24);
  try {
    if (typeof globalThis.crypto?.getRandomValues !== "function") {
      throw new Error("Secure randomness unavailable");
    }
    globalThis.crypto.getRandomValues(bytes);
    // 64 symbols divide the byte range evenly: 24 independent symbols = 144 bits.
    return Array.from(bytes, (byte) => alphabet[byte & 63]).join("");
  } catch {
    throw new Error(
      "Secure generation is unavailable. Enter your own passphrase."
    );
  } finally {
    bytes.fill(0);
  }
};
